import classNames from 'classnames'

import { getQaSelector } from '../../../../../utils/common'
import { stopPropagation } from '../../../../../utils/events'
import { FloatingTooltip } from '../../../../Floating'
import { IconNG } from '../../../../Icon'
import Text from '../../../../Text'

import { QA_NAME_POST_FOOTER_ACTION_CONTEXT } from './NewsboardPostAction.constants'

import * as styles from './NewsboardPostAction.module.css'

function NewsboardPostAction({
  Icon,
  disabledAction,
  disabledIcon,
  qaName,
  title,
  tooltip,
  onClick,
  onClickIcon,
  onMouseDown,
}) {
  const qaProps = getQaSelector({
    context: QA_NAME_POST_FOOTER_ACTION_CONTEXT,
    value: qaName,
  })

  function handleClickIcon(e) {
    if (onClickIcon) {
      stopPropagation(e)
      onClickIcon()
    }
  }

  const actionClassName = classNames(styles.action, {
    [styles.combinedAction]: !onClickIcon,
    [styles.disabledAction]: disabledAction,
    [styles.disabledIcon]: disabledIcon,
  })

  return (
    <FloatingTooltip content={tooltip || title}>
      <div
        {...qaProps}
        className={actionClassName}
        onClick={onClick}
        onMouseDown={onMouseDown}
      >
        <IconNG
          Icon={Icon}
          className={styles.actionIcon}
          onClick={handleClickIcon}
        />
        <Text isSecondary className={styles.actionText}>
          {title}
        </Text>
      </div>
    </FloatingTooltip>
  )
}

export default NewsboardPostAction
